import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type AutorenewProps = IconComponentBaseProps;

export const Autorenew = ({
  className,
  width = 16,
  height = 16,
  fill = defaultTheme.mantineColors.gray[7],
}: AutorenewProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_7511_53297"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7511_53297)">
        <path
          d="M3.83337 8.03302C3.83337 8.22791 3.8466 8.42213 3.87304 8.61568C3.8996 8.80935 3.94493 9.00018 4.00904 9.18818C4.05171 9.33007 4.04721 9.46574 3.99554 9.59518C3.94387 9.72463 3.85604 9.81757 3.73204 9.87402C3.60126 9.93724 3.47115 9.94235 3.34171 9.88935C3.21226 9.83635 3.12615 9.73896 3.08337 9.59718C2.99449 9.34585 2.9306 9.08791 2.89171 8.82335C2.85282 8.55891 2.83337 8.29546 2.83337 8.03302C2.83337 6.59113 3.3351 5.36402 4.33854 4.35168C5.34199 3.33924 6.56249 2.83302 8.00004 2.83302H8.52054L7.63854 1.95102C7.54621 1.85868 7.49899 1.74263 7.49687 1.60285C7.49476 1.46318 7.54199 1.34502 7.63854 1.24835C7.7351 1.15179 7.85215 1.10352 7.98971 1.10352C8.12737 1.10352 8.24449 1.15179 8.34104 1.24835L10.0039 2.91118C10.1244 3.03174 10.1847 3.17235 10.1847 3.33302C10.1847 3.49368 10.1244 3.63429 10.0039 3.75485L8.34104 5.41768C8.24871 5.50991 8.13271 5.55713 7.99304 5.55935C7.85326 5.56146 7.7351 5.51424 7.63854 5.41768C7.54199 5.32102 7.49371 5.20391 7.49371 5.06635C7.49371 4.92879 7.54199 4.81168 7.63854 4.71502L8.52054 3.83302H8.00004C6.84193 3.83302 5.85793 4.24068 5.04804 5.05602C4.23826 5.87146 3.83337 6.86379 3.83337 8.03302ZM12.1667 7.96635C12.1667 7.77146 12.1535 7.57724 12.127 7.38368C12.1005 7.19002 12.0552 6.99918 11.991 6.81118C11.9484 6.66929 11.9529 6.53363 12.0045 6.40418C12.0562 6.27474 12.144 6.18179 12.268 6.12535C12.3988 6.06213 12.5279 6.05702 12.6552 6.11002C12.7825 6.16302 12.8675 6.26041 12.9102 6.40218C12.9991 6.65352 13.0641 6.91146 13.1052 7.17602C13.1462 7.44046 13.1667 7.70391 13.1667 7.96635C13.1667 9.40824 12.665 10.6354 11.6615 11.6477C10.6581 12.6601 9.4376 13.1664 8.00004 13.1664H7.47954L8.36154 14.0484C8.45387 14.1407 8.5011 14.2567 8.50321 14.3965C8.50532 14.5362 8.4581 14.6544 8.36154 14.751C8.26499 14.8476 8.14793 14.8959 8.01037 14.8959C7.87271 14.8959 7.7556 14.8476 7.65904 14.751L5.99621 13.0882C5.87565 12.9676 5.81537 12.827 5.81537 12.6664C5.81537 12.5057 5.87565 12.3651 5.99621 12.2445L7.65904 10.5817C7.75137 10.4895 7.86737 10.4422 8.00704 10.44C8.14682 10.4379 8.26499 10.4851 8.36154 10.5817C8.4581 10.6784 8.50637 10.7955 8.50637 10.933C8.50637 11.0706 8.4581 11.1877 8.36154 11.2844L7.47954 12.1664H8.00004C9.15815 12.1664 10.1422 11.7587 10.952 10.9434C11.7618 10.1279 12.1667 9.13557 12.1667 7.96635Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
